import { render, staticRenderFns } from "./BusinessCreditApplication.vue?vue&type=template&id=565ed630&scoped=true&"
import script from "./BusinessCreditApplication.vue?vue&type=script&lang=js&"
export * from "./BusinessCreditApplication.vue?vue&type=script&lang=js&"
import style0 from "./BusinessCreditApplication.vue?vue&type=style&index=0&id=565ed630&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565ed630",
  null
  
)

export default component.exports